const addTrailingSlash = (url: string) => {
  if (!url) return url;
  if (url[url.length - 1] !== '/') return `${url}/`;
  return url;
};

export default addTrailingSlash;
